import { useTranslation } from "react-i18next";
import { useYesNoAnswer } from "src/utils";

export const useDataEntryVehicleStepInsuranceCompany = () => {
  const { t } = useTranslation();

  const { yesNoOptions } = useYesNoAnswer();

  return { yesNoOptions, t };
};
